import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Col, Row, Portlet, Form, Button } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as CompraService from 'services/compra.service'

import * as FormGroups from './formGroups'

const FormatoReporteOrdenes = () => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      fechaDesde: '',
      fechaHasta: '',
      tipoReporte: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      if (!data.fechaDesde || !data.fechaHasta) {
        __zariContext.snack('warning', 'Seleccionar fechas')
        setSubmitting(false)
        return
      }
      if (!data.tipoReporte) {
        __zariContext.snack('warning', 'Seleccionar el tipo de reporte')
        setSubmitting(false)
        return
      }
      __zariContext.loader.open('Descargando reporte ordenes...')
      CompraService.descargarReporteOrdenes(data)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
          __zariContext.toast('success', 'El reporte se ha descargado.')
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          setSubmitting(false)
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header title='Reporte Ordenes' />
      <Portlet.Body>
        <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
          {({ errors, touched, isSubmitting, values, setValues, handleSubmit }) => (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroups.FechaDesdeFormGroup
                    iError={errors.fechaDesde}
                    iTouched={touched.fechaDesde}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.FechaHastaFormGroup
                    iError={errors.fechaHasta}
                    iTouched={touched.fechaHasta}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <FormGroups.TipoReporteOrdenFormGroup
                iValue={values.tipoReporte}
                fIsSubmitting={isSubmitting}
                iError={errors.tipoReporte}
                setValues={setValues}
                values={values}
              />
              <Row>
                <Col md={12} className='text-right'>
                  <Button id='button-reporteCompras-submit' tiny onClick={handleSubmit} disabled={isSubmitting}>
                    Descargar
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(FormatoReporteOrdenes)
